import { Select, Skeleton } from 'antd'
import { useEffect, useState } from 'react';
import { Language } from '../../../models/Language';
import { useAppConfig } from '../../../Contexts/AppConfigContext';
import { DEFAULT_LANGUAGE } from '../../../i18n/i18n';
import { GetAppLanguage, UpdateAppLanguage } from '../../../RoutesApp';

import './LanguageSelectorInLineComponent.scss';
import { GetArrowSelectIcon } from '../../../utils/icons';

const LanguageSelectorInLineComponent = () : JSX.Element =>{

    const appConfig = useAppConfig();
    const navigationLanguage = GetAppLanguage();

    const [availableClientLanguages, setAvailableClientLanguages] = useState<Language[]>([]);

    const getAvailableClientLanguages = () : void => {
        if (appConfig && appConfig.config.availableLanguages){
            setAvailableClientLanguages(appConfig.config.availableLanguages);
        }
    }

    const changeLanguage = (shortCode: string) : void => {
        if (shortCode && shortCode.length > 0){
            UpdateAppLanguage(shortCode.toLowerCase());
        }else{
            UpdateAppLanguage(DEFAULT_LANGUAGE);
        }
    }

    useEffect(()=>{
        getAvailableClientLanguages();
    },[appConfig])

    return (
        <div className="inline-language-selector">
            {
                availableClientLanguages && availableClientLanguages.length > 0
                ?
                    <ul>
                        {
                            availableClientLanguages.map((l: Language) => {
                                const isActive = l.shortCode.toLowerCase() === navigationLanguage.toLowerCase();
                                return <li key={l.shortCode} className={isActive ? 'active' : ''} onClick={()=>{changeLanguage(l.shortCode)}}>{l.description}</li>
                            })
                        }
                    </ul>
                :
                    <Skeleton.Input active size={'small'} />
            }
        </div>
    )
}

export default LanguageSelectorInLineComponent;